module.exports = __webpack_public_path__ + "static/media/GoogleSheetsAddToSheet-01.e890a632.svg";